const htmlToPlain = (html) => html.replace(/<\/?[^>]+>/gi, ' ');

export default htmlToPlain;
